/**
 * Parses a string of format dd-MM-YYYY or dd/MM/YYYY into a Date object.
 */
export function parsePastedDate(txt: string): Date {
	// Remove \r and \n, these are added automatically when pasting a date cell from Excel
	txt = txt.split('\r').join('').split('\n').join('');
	// Replace / with -
	txt = txt.split('/').join('-').trim();
	// split by -, create a date object from the day, month, and year if possible
	const substrings = txt.split('-');
	if (substrings.length === 3) {
		const day: number = Number.parseInt(substrings[0], 10);
		const month: number = Number.parseInt(substrings[1], 10);
		const year: number = Number.parseInt(substrings[2], 10);
		if (!Number.isNaN(day) && !Number.isNaN(month) && !Number.isNaN(year)) {
			if (1 <= day && day <= 31 && 1 <= month && month <= 12) {
				return new Date(year, month - 1, day);
			}
		}
	}
	return null;
}
